import type { ReactNode } from "react";

/** Primary app destinations, shared by the desktop NavBar and the mobile tab
 *  bar. `icon` is the inner content of a 24x24 stroke-based SVG. */
export type AppLink = {
  to: string;
  label: string;
  end?: boolean;
  icon: ReactNode;
};

export const LINKS: AppLink[] = [
  {
    to: "/",
    label: "Practice",
    end: true,
    icon: (
      <>
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
      </>
    ),
  },
  {
    to: "/dashboard",
    label: "Progress",
    icon: (
      <>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </>
    ),
  },
  {
    to: "/vocabulary",
    label: "Vocabulary",
    icon: (
      <>
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </>
    ),
  },
  {
    to: "/exercises",
    label: "Exercises",
    icon: (
      <>
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </>
    ),
  },
  {
    to: "/calendar",
    label: "Calendar",
    icon: (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </>
    ),
  },
  {
    to: "/knowledge",
    label: "Library",
    icon: (
      <>
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </>
    ),
  },
];

/** Desktop nav and mobile tab bar show the five core destinations; Library
 *  moves into the profile menu on both. */
export const TAB_LINKS = LINKS.filter((l) => l.to !== "/knowledge");
